module.exports = {
          srcSet: __webpack_public_path__ + "3eb84a5d.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "3eb84a5d.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "3eb84a5d.jpg",
          toString:function(){return __webpack_public_path__ + "3eb84a5d.jpg"},
          
          width: 330,
          height: 200
        }